import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'

import Image from 'components/common/ImageLoader'
// import Logo from 'assets/intrigue_logo.png';
import './index.css'

const SignupPage = (pros) => {
    return (
        <div className="mt-40 signup-container">
            <div className="my-10 flex flex-wrap items-center justify-center">
                {/* <Image width={100} height={100} src={Logo} /> */}
            </div>
            <div className="flex flex-wrap items-center justify-center">
                <div class=" bg-gray-200 rounded-lg p-8 flex flex-col w-128">
                    <h2 class="text-gray-900 text-lg font-medium title-font mb-5">
                        Create a new account
                    </h2>

                    <Formik
                        initialValues={{ email: '', password: '' }}
                        validate={(values) => {
                            const errors = {}
                            if (!values.email) {
                                errors.email = 'Required'
                            } else if (
                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                    values.email
                                )
                            ) {
                                errors.email = 'Invalid email address'
                            }

                            if (!values.password) {
                                errors.password = 'Required'
                            }
                            return errors
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            setTimeout(() => {
                                alert(JSON.stringify(values, null, 2))
                                setSubmitting(false)
                            }, 400)
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                {/* <label htmlFor="password">Enter your email</label> */}
                                <Field
                                    className="w-full bg-white rounded border border-gray-400 focus:outline-none focus:border-primary-500 text-base px-4 py-2 mb-4"
                                    type="email"
                                    name="email"
                                    placeholder="Please enter your email"
                                />
                                <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="text-reds-r500 -mt-4 mb-2"
                                />

                                {/* <label htmlFor="password">Create password</label> */}
                                <Field
                                    id="password"
                                    className="w-full bg-white rounded border border-gray-400 focus:outline-none focus:border-primary-500 text-base px-4 py-2 mb-4"
                                    type="password"
                                    name="password"
                                    placeholder="Please enter your password"
                                />
                                <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="text-reds-r500 -mt-4 mb-2"
                                />
                                <div>
                                    <button
                                        class="text-white bg-primary-500 border-0 py-2 px-8 focus:outline-none hover:bg-primary-500 rounded text-lg"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        Create
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>

                    <p class="text-xs text-gray-500 mt-3">
                        If you are experiencing any difficulty, please contact{' '}
                        <a
                            className="text-primary-500 font-light"
                            href="mailto:hello@intrigue.io"
                        >
                            hello@intrigue.io
                        </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SignupPage
